import React, { useEffect, useState, useCallback } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { auth, db, updateAccount } from "../firebase";
import { query, collection, getDocs, where } from "firebase/firestore";
import Header from "../components/Header";

function Profile() {
  const [user, loading, error] = useAuthState(auth);
  const [name, setName] = useState("");
  const [docname, setDocname] = useState("");
  const [counter, setCounter] = useState("");
  const [credits, setCredits] = useState("");
  //const [email, setEmail] = useState("");
  const navigate = useNavigate();

  /* const fetchUserName = async () => {
    try {
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setName(data.name);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  }; */

  // refactoring: https://typeofnan.dev/fix-function-makes-the-dependencies-of-useEffect-hook-change-on-every-render-warning-in-react/
  const fetchUserName =  useCallback( async () => {
    try {
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      const documentName = doc.docs[0].id;
      setName(data.name);
      setCounter(data.ratingCounter);
      setDocname(documentName);
      setCredits(data.credits);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  }, [user]);




  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
    fetchUserName();
  }, [user, loading, error, navigate, fetchUserName]);
  console.log(user);
  return (
    <>
    {loading === false ? (
    <div className="mb-0 px-3 main_screen">

      <Header key="1"  user={user} />

      <h2 className="p-2">Account</h2>

      <div className="p-2 dashboard___ align-start">
        <form className="account_form" onSubmit={(e) => updateAccount(e, name, docname) } >
          <input type="hidden" name="documentName" value={docname} readOnly id="documentName" />
          <label htmlFor="name">Name</label>
          <input
              id="name"
              type="text"
              className="textbox form-control editable"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Name"
              required
            />
          <label htmlFor="email" className="mt-3">E-mail</label>
          <input
              id="email"
              type="email"
              className="textbox form-control"
              value={user?.email}
              readOnly
              placeholder="E-mail"
              required
            />

          {/* <div>{user?.uid}</div>
          <div>Access token: <br /> {user?.accessToken}</div>
          <div>Refresh token: <br /> {user?.refreshToken}</div> */}
          <button
            type="submit"
            className="btn btn-primary mt-4 mb-2 py-2"
          >
            Save
          </button>
        </form>
        <div className="rating_counter text-center mt-5">
          <div className="rating_counter_numbers">{counter ? counter : 0} <span>/</span> {credits} </div>
          <div>free ratings used</div>
        </div>
        <a className="btn btn-primary btn-buy mt-4 mb-2 py-2" href="/profile">Buy 1000 ratings</a>
      </div>
    </div>
    ) : (
    <div className="loadingscreen">
      <div className="loading spinner-border text-warning"></div>
    </div>
    ) }
    </>
  );
}

export default Profile;
